import { round } from '../services';
import variables from './commonConstant.scss';

export default {};

export const CHALLENGE = {
  teamDashboard: {
    teamInfoStepsHeading: 'ก้าวเดินวันนี้',
    totalStepsHeading: 'ก้าวเดินรวม',
    totalDistanceHeading: 'ระยะทางรวม',
    stepsUnit: 'ก้าว',
    minuteUnit: 'นาที',
    kilometerUnit: 'กม.',
    caloriesUnit: 'แคลอรี่',
    vdoHeading: 'ดูวิดีโอและ',
    vdoSubHeading: 'ทำแบบทดสอบ',
    average: 'เฉลี่ยวันละ',
    cumulativeSteps: 'ก้าวเดินสะสม',
    bmiHeading: 'BMI ดัชนีมวลกาย(ชั่งก่อน)',
    bmiweighOutHeading: 'BMI ดัชนีมวลกาย(ชั่งจบ)',
    bmiMessage: 'ร่างกายสมส่วน',
    teamName: 'ทีม: ',
    teamInfoHeading: 'สมาชิกทีม',
    medals: 'เหรียญรางวัล',
    teamCompositionFinalWeighing: '*คำนวณจากข้อมูลการชั่งจบการแข่งขัน',
    teamCompositionHeading: 'ความเปลี่ยนแปลงร่างกายรวมของทีม',
    teamCompositionMessage: '*คำนวณจากน้ำหนักที่ทำการบันทึกระหว่างแข่งขัน',
    teamCompositionSubMessage: '(จะไม่ถูกนำไปรวมกับการให้รางวัล)',
    totalStepsToBeTakenToday: '10000',
    maxBadges: '40',
    averageMuscleHeading: 'มวลกล้ามเนื้อ เฉลี่ย',
    avergeFatHeading: 'มวลไขมัน เฉลี่ย',
    averageWeightHeading: 'น้ำหนัก เฉลี่ย',
    kilogram: 'กก.',
    teamWeightHeading: 'น้ำหนัก',
    teamFatHeading: 'มวลไขมัน',
    teamMuscleHeading: 'มวลกล้ามเนื้อ',
    bmi: 'BMI',
    teamHeaderBadge: 'นธอ. ใหม่',
    teamStepsCardHeader: 'วันที่',
    bmiTag: 'เกณฑ์ปกติ',
    missingTeam: 'ขาดสมาชิก',
    membersTeam: 'คน',
    maxTeamMembers: 4,
    teamBodyHeading: 'ข้อมูลองค์ประกอบร่างกายรวมของทีม',
    teamBodySubHeading: 'ชั่งก่อนการแข่งขัน',
    weightInAtEndChallenge: 'ชั่งจบการแข่งขัน',
    weightInBeforeChallenge: 'ชั่งก่อนการแข่งขัน',
    teamNewAboTitle: 'นธอ. ใหม่',
    detailBtnTitle: 'ดูรายละเอียดการแข่งขัน',
    distanceConstant: 0.000762,
    missionSliderHeader: 'ภารกิจ 60 วัน สะสมเหรียญพิชิตรางวัล',
    bodyDataSliderHeader: 'ชั่งก่อนการแข่งขัน',
    teamProfileHeader: 'สมาชิกทีม',
    teamProfileFirstName: 'จิดา',
    teamProfileLastName: 'พรหมวงศ์วิจิตร',
    dashboardFooterLeftBtnTitle: 'เหรียญรางวัลของฉัน',
    dashboardFooterRightBtnTitle: 'เข้าสู่แผนที่',
    teamNewMemberTitle: 'สมาชิกใหม่',
    mapLocationTab: 'ปิรามิดแห่งกีซ่า, อียิปต์',
    mapUsersTab: 'อันดับการปลดล็อก',
    mapLocationTitle: 'ปลดล็อกเมื่อ',
    mapGoalTitle: 'เดินอีก',
    mapGoalTitleSteps: 'ก้าว',
    mapGoalSubtitle: 'เพื่อไปยังจุดหมายถัดไป',
    noUser: '-ว่าง-',
    businessOwner: 'businessowner',
    businessMember: 'member',
    refreshInterval: 150000, // 2 minutes 30 seconds
    myFatHeading: 'ไขมัน',
  },
  beginTeamDashboard: {
    challengeDetailFooterButton: "แดชบอร์ดของฉัน",
    dashboardFooterLeftBtnTitle: 'ทำเช็กลิสต์',
    dashboardFooterRightBtnTitle: 'เงื่อนไขการรับรางวัล',
    dashboardFooterWaitingBtnTitle: 'เงื่อนไขกิจกรรม',
    ongoingHeader: 'วันที่',
    summaryCardPrimarytitle: "คะแนนรวมทีม",
    summaryCardSecondarytitle: "ผ่านเกณฑ์ (เช็คลิสต์)",
    summaryCardSecondarySubtitle: '200 คะแนนขึ้นไปต่อคน',
    teamHealthspanCardTitle: "Healthspan Score ล่าสุด",
    teamHealthspanCardSubtitle: '(ระหว่างวันที่ 31-37 ของการแข่งขัน)',
    teamInfoHeading: 'สมาชิกทีม',
    vacantSlotTitle: '- ว่าง -',
    healthspanScoreTitle: 'Healthspan Score',
    healthspanScoreCaption: 'ข้อมูลวันเริ่มแข่ง',
    scoreEarnedTitle:'ทำคะแนนเพิ่ม',
    scoreEarnedCaption: 'เพื่อผ่านเกณฑ์เช็คลิสต์',
    accumulatedScoreTitle: 'คะแนนสะสม',
    healthspanScoreCardtext1: 'ทำคะแนน',
    healthspanScoreCardtext2: 'คะแนนขึ้นไป (+10%) เพื่อผ่านเกณฑ์รับรางวัล'
  },
  me: {
    maxTeamMembers: 1
  },
  buddy: {
    maxTeamMembers: 2
  },
  team: {
    maxTeamMembers: 4
  },
  challengeQuiz: {
    submitButtonText: 'ยืนยันคำตอบ',
    quizVideoText: 'วิดีโอ',
    seeAllText: 'ดูทั้งหมด',
    quizContainerHeading: 'คำถาม',
    quizReviewHeading: 'กรุณายืนยันคำตอบ',
    reviewBackBtn: 'แก้ไข',
  },
  myDashboard: {
    maxUserSteps: '/10,000',
    stepsUnit: 'ก้าว',
    stepTodayHeading: 'ก้าวเดินวันนี้',
    accStepHeading: 'ก้าวเดินสะสม',
    skuText: 'รหัส: ',
    compositionHeading: 'ความเปลี่ยนแปลงร่างกาย',
    compositionMessage: '*คำนวณจากน้ำหนักที่ทำการบันทึกระหว่างแข่งขัน',
    compositionSubMessage: '(จะไม่ถูกนำไปรวมกับการให้รางวัล)',
    height: 'ส่วนสูง',
    weight: 'น้ำหนัก',
    fatMass: 'มวลไขมัน',
    muscleMass: 'มวลกล้ามเนื้อ',
    heightUnit: 'ซม.',
    kilogram: 'กก.',
    missionSectionHeading: 'ภารกิจ ',
    missionSectionSubHeading: ' วัน สะสมเหรียญพิชิตรางวัล',
    fitPerformer: 'Fit Performer',
    fitPerform: 'การออกกำลังกาย',
    maxStepsForTeam: '/600,000',
    bestDiscipliner: 'The Best Discipliner',
    goalKeeper: 'The Goal Keeper',
    bestLearner: 'The Best Learner',
    topLearner: 'Top Learner',
    maxRewardBadges: '/60',
    days: 'วัน',
    videos: 'วิดีโอ',
    points: 'คะแนน',
    badgePoints: 'พอยท์',
    dashboardFooterLeftBtnTitle: 'ภารกิจและรางวัล',
    dashboardFooterRightBtnTitle: 'เข้าสู่แผนที่',
    maxBadgeActiveValue: 50,
    fatPercentage: 'ไขมัน %',
    percentUnit: '%',
  },
  mapDetail: {
    share: 'แชร์:',
  },
  badges: {
    smartLearnerHeading: 'Smart Learner',
    smartLearnerHeader: 'การเรียนรู้',
    dietPlanner: 'Diet Planner',
    diePlannerHeader: 'การจัดการแคลอรี',
    perfectWorkout: 'The Best Discipliner',
    achievedBadgeHeading: 'คุณได้รับเหรียญนี้จากก้าวเดินสะสมในการแข่งขัน',
    bodyKey10Heading: 'Bodykey Challenge ครั้งที่ 10',
    accumulating: 'เดินครบ',
    stepsUnit: 'ก้าว',
    disabledHeading: 'เพื่อพิชิตเหรียญนี้',
    disabledSubHeading: 'ตลอดระยะเวลาการแข่งขัน',
    complete: 'คุณต้องมีก้าวเดินสะสมอย่างน้อย',
    usersHeading: 'ประวัติการได้รับเหรียญ',
    FoodMissionBadgeHeading: 'กรอกเมนูอาหารครบ 3 มื้อต่อวัน ตลอด 60 วัน',
    CalorieMissionBadgeHeading: 'ควบคุมแคลอรีต่อวันไม่ให้เกินเป้าหมายที่ตั้งไว้',
    QuizHeading: 'ทำแบบทดสอบตอบถูก 1 ข้อ รับ 1 พอยท์',
    QuizSubHeading: 'สะสมพอยท์อย่างน้อย 50 พอยท์',
    VdoHeading: 'รับชมคลิปวิดีโอความรู้ 1 คลิป รับ 1 พอยท์',
    VdoSubHeading: 'สะสมอย่างน้อย 50 พอยท์',
    FoodNoteText: 'หมายเหตุ: ข้อมูล ณ วันปัจจุบันจะบันทึกคะแนนให้ในวันถัดไป',
    FoodCalorieSubHeading: 'รับ 1 พอยท์ สะสมอย่างน้อย 50 พอยท์',
    receivedWhen: 'ได้รับเมื่อ',
    receivedOn: 'เมื่อ',
    steps: 'steps',
    vdo: 'vdo',
    quiz: 'quiz',
    calorie: 'calorie',
    food: 'food',
    heading: 'เหรียญรางวัลกิจกรรม',
    others: 'others'
  },
  reward: {
    rewardValue: 'มูลค่า',
    rewardCurrency: '฿',
    activityRewards: 'รางวัลกิจกรรม',
    rewardPrize: 'รับรางวัลภายใน  ',
    rewardDays: 'วัน',
    rewardButton: 'ดูรางวัล',
    approved: 'รอรับรางวัล',
    pending: 'รอชำระเงิน',
    rejected: 'ไม่ผ่านเกณฑ์',
    order_placed: 'รับรางวัลแล้ว',
    waiting_to_received: 'APPROVED',
    not_qualified: 'REJECTED',
    waiting_for_payment: 'PENDING',
    received: 'ORDER_PLACED',
    noRewardTitle: 'ยังไม่มีรางวัลในขณะนี้',
    noRewardImage: '/images/challenge/no-rewards.svg'
  },
  type: {
    TEAM: 'TEAM',
    BUDDY_ME: 'BUDDY_ME',
    BUDDY: 'BUDDY',
    ME: 'ME',
    CHALLENGE_11: 'CHALLENGE_11',
    CHALLENGE_12_TEAM: 'CHALLENGE_12_TEAM'
  },
  quizAndVideoButtonText: {
    calorie: 'ตั้งเป้าหมาย',
    food: 'บันทึกมื้ออาหาร',
    vdo: 'ทำภารกิจดูวิดีโอ - ทำแบบทดสอบ',
    quiz: 'ทำภารกิจดูวิดีโอ - ทำแบบทดสอบ'
  },
  quizStatus: {
    initial: 'initial',
    review: 'review',
    submit: 'submit'
  },
  map: {
    bodykeyChallengeHeading: 'BodyKey Challenge 2026'
  }
};

export const CHALLENGE_LIST = {
  HOME_TABS_MAPPING: [
    { name: 'ongoing', label: 'การแข่งที่เริ่มแล้ว' },
    { name: 'upcoming', label: 'การแข่งที่กำลังมา' },
  ],
  TYPES: {
    upcoming: 'upcoming',
    ongoing: 'ongoing',
    completed: 'completed',
  },
  TYPE_MAP: {
    การแข่งที่เริ่มแล้ว: 'ongoing',
    การแข่งที่กำลังมา: 'upcoming',
  },
  TITLE_MAP: {
    ongoing: 'การแข่งขันที่เริ่มแล้ว',
    upcoming: 'การแข่งขันที่เปิดรับสมัคร',
  },
  CAROUSEL_RENDER_MAP: {
    home: 'home',
    listPage: 'list',
  },
};

export const CHALLENGE_STEPS_FOOD_KEY_MAPPING = {
  steps: {
    id: 'dc19825a-3986-4c12-ab57-99898bb62bb2',
    title: 'ก้าวสะสม',
    key_map: 'total_step',
    daily_key_map: 'round_details',
    daily_key_value: 'step',
    unit: '(ก้าว)',
  },
  food: {
    id: '530f7c0a-9d1d-40e2-8d9b-9a6320c2259e',
    title: 'บันทึกการกิน',
    key_map: 'total_food_log',
    daily_key_map: 'food_log',
    daily_key_value: 'status',
    unit: '(วัน)',
  },
  calorie: {
    id: '166b6b06-0311-42f6-9cc4-54db352946c9',
    title: 'บันทึกแคลอรี',
    key_map: 'total_calories_log',
    daily_key_map: 'calories_log',
    daily_key_value: 'status',
    unit: '(วัน)',
  },
  vdo: {
    id: '6f3a85ca-769b-49cb-aede-79d401985669',
    title: 'ดูวิดีโอ',
    key_map: 'total_vdo_log',
    daily_key_map: 'vdo_log',
    daily_key_value: 'link',
    unit: '(วิดีโอ)',
  },
  quiz: {
    id: '760faf13-903a-4b82-b677-ab7ed5bbc7f6',
    title: 'แบบทดสอบ',
    key_map: 'total_badge',
    daily_key_map: '',
    daily_key_value: '',
    unit: '(คะแนน)',
  },
};

export const BEGIN_CHALLENGE_SCORE_KEY_MAPPING = {
  //todo: there was a crash happening in assesmnet.reduler if we remove these extra entries
  score: {
    id: 'd5030f8f-6f3e-4b22-b6e8-5ac97ae7b816',
    title: 'Accumulated points',
    key_map: 'score',
    daily_key_value: 'score',
  },
  steps: {
    id: 'dc19825a-3986-4c12-ab57-99898bb62bb2',
    title: 'ก้าวสะสม',
    key_map: 'total_step',
    daily_key_map: 'round_details',
    daily_key_value: 'step',
    unit: '(ก้าว)',
  },
  food: {
    id: '530f7c0a-9d1d-40e2-8d9b-9a6320c2259e',
    title: 'บันทึกการกิน',
    key_map: 'total_food_log',
    daily_key_map: 'food_log',
    daily_key_value: 'status',
    unit: '(วัน)',
  },
  calorie: {
    id: '166b6b06-0311-42f6-9cc4-54db352946c9',
    title: 'บันทึกแคลอรี',
    key_map: 'total_calories_log',
    daily_key_map: 'calories_log',
    daily_key_value: 'status',
    unit: '(วัน)',
  },
  vdo: {
    id: '6f3a85ca-769b-49cb-aede-79d401985669',
    title: 'ดูวิดีโอ',
    key_map: 'total_vdo_log',
    daily_key_map: 'vdo_log',
    daily_key_value: 'link',
    unit: '(วิดีโอ)',
  },
  quiz: {
    id: '760faf13-903a-4b82-b677-ab7ed5bbc7f6',
    title: 'แบบทดสอบ',
    key_map: 'total_badge',
    daily_key_map: '',
    daily_key_value: '',
    unit: '(คะแนน)',
  },
};

export const EVENT_NAME_BDK_CHALLENGE_2026 = 'BODYKEY_CHALLENGE_2026';

export const CHALLENGE_BODY_KEY_MAPPING = {
  weight: {
    title: 'น้ำหนัก',
    key: 'weight',
    key_map: 'weight',
    unit: '(กก.)',
  },
  height: {
    title: 'ส่วนสูง',
    key: 'height',
    key_map: 'height',
    unit: '(ซม.)',
  },
  fat: {
    title: 'มวลไขมัน',
    key: 'fat',
    key_map: 'kg_cal',
    unit: '(กก.)',
  },
  muscle: {
    title: 'มวลกล้ามเนื้อ',
    key: 'muscle',
    key_map: 'kg',
    unit: '(กก.)',
  },
  bmi: {
    title: 'BMI',
    key: 'bmi',
    key_map: 'bmi',
    unit: '',
  },
  fat_percent: {
    title: 'ไขมัน %',
    key: 'fat',
    key_map: '%',
    unit: '%',
  },
};

export const CHALLENGE_BEGIN_KEY_MAPPING = {
  healthspan_score: {
    title: 'สุขภาพ',
    key: 'healthspan',
    key_map: 'healthspan_score',
    unit: '',
  },
  weight: {
    title: 'น้ำหนัก',
    key: 'weight',
    key_map: 'weight',
    unit: '(กก.)',
  },
  height: {
    title: 'ส่วนสูง',
    key: 'height',
    key_map: 'height',
    unit: '(ซม.)',
  },
  fat: {
    title: 'มวลไขมัน',
    key: 'fat',
    key_map: 'kg_cal',
    unit: '(กก.)',
  },
  muscle: {
    title: 'มวลกล้ามเนื้อ',
    key: 'muscle',
    key_map: 'kg',
    unit: '(กก.)',
  },
  bmi: {
    title: 'BMI',
    key: 'bmi',
    key_map: 'bmi',
    unit: '',
  },
  fat_percent: {
    title: 'ไขมัน %',
    key: 'fat',
    key_map: '%',
    unit: '%',
  },
};

export const WEIGHT_IN_DIFF_MAPPING = {
  weight: {
    key: 'daily',
    key_map: 'weight_change',
  },
  fat: {
    key: 'daily',
    key_map: 'fat_change',
  },
  muscle: {
    key: 'daily',
    key_map: 'muscle_change',
  },
};

export const WEIGHT_OUT_DIFF_MAPPING = {
  weight: {
    key: 'cal',
    key_map: 'weight_change',
  },
  fat: {
    key: 'cal',
    key_map: 'fat_mass_change',
  },
  muscle: {
    key: 'cal',
    key_map: 'muscle_mass_change',
  }
};

export const PERIOD_DATA_MAPPING = {
  registerPeroid: 'REGISTER',
  weightOutPeriod: 'FINAL',
};

export const rectBadgeClassname = {
  not_yet_started: {
    classname: 'no-member-badge',
    title: 'เพิ่มสมาชิกภายใน',
    text: 'ขาด',
    textAfter: 'คน',
  },
  ready_to_start: {
    classname: 'success-badge',
    title: 'พร้อมแข่งขัน',
    text: 'สมาชิกครบ',
    iconUrl: '/images/challenge/icons/challenge-tag-complete.svg',
  },
  ongoing: {
    classname: 'success-badge',
    tagClassName: 'ongoing-badge',
    title: 'กำลังแข่งขัน',
    text: 'แข่งวันที่',
  },
  weight_end: {
    classname: 'warning-badge',
    title: 'ชั่งจบการแข่งขัน',
    text: 'รอชั่งจบ',
    iconUrl: '/images/challenge/icons/challenge-tag-waiting.svg',
  },
  end_challenge: {
    classname: 'no-member-badge',
    tagClassName: 'success-badge',
    title: 'รับรางวัลภายใน',
    iconUrl: '/images/challenge/icons/challenge-tag-complete.svg',
    text: 'แข่งจบแล้ว',
  },
  remove_team: {
    classname: 'error-badge',
    title: 'ออกจากการแข่ง',
    text: 'ออกจากการแข่ง',
  },
  reward_period: {
    classname: 'no-member-badge',
    tagClassName: 'success-badge',
    title: 'รับรางวัลภายใน',
    text: 'แข่งจบแล้ว',
    iconUrl: '/images/challenge/icons/challenge-tag-complete.svg',
  },
  yet_to_watch: {
    classname: 'yet-to-watch-badge',
    title: 'ยังไม่ได้ดู',
    text: 'ยังไม่ได้ดู',
  },
  watch_not_fully: {
    classname: 'watch-unsuccessful-badge',
    title: 'ยังดูไม่สำเร็จ',
    text: 'ยังดูไม่สำเร็จ',
  },
  watch_successful: {
    classname: 'watch-success-badge',
    title: 'ดูสำเร็จแล้ว',
    text: 'ดูสำเร็จแล้ว',
  },
  begin_add_member: {
    classname: 'add-member-badge',
    title: 'เพิ่มสมาชิกภายใน',
    tagClassName: 'add-member-badge', // used by ChallengeTag (carousel card)
    text: 'เหลือ', // used by ChallengeTag (carousel card) 
    textAfter: 'คน', //used in carousel           
  },
  begin_ready_to_start: {
    classname: 'challenge-started-badge',
    title: 'เตรียมแข่งขัน',
    tagClassName: 'success-badge',
    text: 'สมัครครบ',
    iconUrl: '/images/challenge/icons/challenge-tag-complete.svg',
  },
  begin_ongoing: {
    classname: 'challenge-started-badge',
    title: 'กำลังแข่งขัน',
    tagClassName: 'challenge-started-badge',
    text: 'กำลังแข่ง',
  },
  begin_weight_end: {
    classname: 'challenge-started-badge',
    title: 'ชั่งจบการแข่งขัน',
    text: 'รอชั่งจบ',
    iconUrl: '/images/challenge/icons/challenge-tag-complete.svg',
  }
};

export const singleBadgeClassname = {
  not_yet_started: {
    classname: 'error-badge',
    title: 'ทีมจะถูกยกเลิกภายใน',
    icon: '/images/challenge/icons/team-dashboard-caution.svg',
    subtitle: 'วัน หากสร้างทีมไม่สำเร็จ',
  },
  weight_end: {
    classname: 'warning-badge',
    title: 'เหลือเวลาชั่งจบ',
    icon: '/images/challenge/icons/team-dashboard-caution-weight.svg',
    subtitle: 'วัน',
  },
};

export const teamInfoBadgeClass = {
  profile: {
    title: 'นธอ. ใหม่',
  },
};

export const teamMaxSize = 4;

export const challengeTypeMaxSize = {
  ME: { type: 'me', maxSize: 1 },
  BUDDY: { type: 'buddy', maxSize: 2 },
  TEAM: { type: 'team', maxSize: 4 }
};

export const CHALLENGE_QUIZ_LABELS = [
  { label: 'ก' },
  { label: 'ข' },
  { label: 'ค' },
  { label: 'ง' },
];

export const CHALLENGE_ANSWER_LABELS = {
  correctAns: '/images/challenge/correct.svg',
  incorrectAns: '/images/challenge/incorrect.svg',
};

export const QUIZ_HEADER = {
  LEFT_ICON: '/images/challenge/arrow-black.svg',
  RIGHT_ICON: '/images/challenge/team-dashboard.svg',
};

export const QUIZ_REVIEW_HEADER = {
  LEFT_ICON: '/images/challenge/arrow-black.svg',
};

export const VIDEO_DETAIL_HEADER = {
  LEFT_ICON: '/images/challenge/arrow-black.svg',
  RIGHT_ICON: '/images/challenge/team-dashboard.svg',
};

export const QUIZ_DETAILS = {
  quiz_pending: {
    score_text: 'ข้อ',
    date_text: 'ภายใน',
    time_img_url: '/images/challenge/time.svg',
    time_className: '',
  },
  quiz_completed: {
    score_text: 'พอยท์',
    date_text: 'ทำเสร็จเมื่อ',
    time_img_url: '/images/challenge/Solid-Circle-Check.svg',
    time_className: 'time-value-green',
  },
};

export const ChallengeTeamdashboardStatus = {
  not_yet_started: 'not_yet_started',
  ready_to_start: 'ready_to_start',
  weight_end: 'weight_end',
  remove_team: 'remove_team',
  end_challenge: 'end_challenge',
  ongoing: 'ongoing',
  reward_period: 'reward_period',
  begin_add_member: 'begin_add_member',
  begin_ready_to_start: 'begin_ready_to_start',
  begin_ongoing: 'begin_ongoing',
  begin_weight_end: 'begin_weight_end'
};

export const noChallengeText = {
  top: 'เตรียมพบกับการแข่งขัน',
  middle: 'หลากหลายรูปแบบจากแอมเวย์',
  bottom: 'เร็วๆ นี้!',
};

export const CHALLENGE_DETAIL = {
  maxContentHeight: 500,
  minContentHeight: 400,
  minContentHeightSm: 330,
  dragEvents: ['mousemove', 'touchmove'],
  dragEndEvents: ['mouseup, touchend'],
  dateFormat: 'dd MMM yyyy',
  buttonMap: {
    registered: 'แดชบอร์ดของฉัน',
    participate: 'เข้าร่วม',
    invite: 'ชวนเพื่อน',
  },
  buttonTypes: {
    registered: 'registered',
    participate: 'participate',
    invite: 'invite',
  },
};

export const CHALLENGE_MAP = {
  INITIAL_SCALE: 1,
  MAP_WIDTH: 534,
  MAP_HEIGHT: 300,
  BUBBLE_AHEAD_MESSAGE: 'รีบตามมานะ 😎',
  BUBBLE_BEHIND_MESSAGE: 'กำลังตามไปจ้า! 🤩',
};

export const MAP_TARGET_BADGE_IMG = [
  {
    target_img: 'egypt',
    thumbnailText: 'พีระมิดแห่งกีซา',
    badge_unlocked_img: '',
  },
  {
    target_img: 'peru',
    thumbnailText: 'มาชูปิกชู',
    badge_unlocked_img: 'egypt',
  },
  {
    target_img: 'usa',
    thumbnailText: 'เทพีเสรีภาพ',
    badge_unlocked_img: 'peru',
  },
  {
    target_img: 'france',
    thumbnailText: 'หอไอเฟล',
    badge_unlocked_img: 'usa',
  },
  {
    target_img: 'nepal',
    thumbnailText: 'เอเวอเรสต์',
    badge_unlocked_img: 'france',
  },
  {
    target_img: 'japan',
    thumbnailText: 'ภูเขาไฟฟูจิ',
    badge_unlocked_img: 'nepal',
  },
];
export const BUDDY_ME_MAP_TARGET_BADGE_IMG = [
  {
    target_img: 'khaoyai',
    thumbnailText: 'เขาใหญ่',
    badge_unlocked_img: '',
  },
  {
    target_img: 'inthanon',
    thumbnailText: 'ดอยอินทนนท์',
    badge_unlocked_img: 'khaoyai',
  },
  {
    target_img: 'myanmar',
    thumbnailText: 'พุกาม',
    badge_unlocked_img: 'inthanon',
  },
  {
    target_img: 'laos',
    thumbnailText: 'วังเวียง',
    badge_unlocked_img: 'myanmar',
  },
  {
    target_img: 'cambodia',
    thumbnailText: 'นครวัด',
    badge_unlocked_img: 'laos',
  },
  {
    target_img: 'vietnam',
    thumbnailText: 'บาน่าฮิลล์',
    badge_unlocked_img: 'cambodia',
  },
];
export const CHALLENGE_11_MAP_TARGET_BADGE_IMG = [
  {
    target_img: 'zhujia',
    thumbnailText: 'จูเจียเจี่ยว',
    badge_unlocked_img: '',
  },
  {
    target_img: 'yugarden',
    thumbnailText: 'สวนอี้หยวน',
    badge_unlocked_img: 'zhujia',
  },
  {
    target_img: 'buddha',
    thumbnailText: 'วัดพระหยกขาว',
    badge_unlocked_img: 'yugarden',
  },
  {
    target_img: 'shanghai',
    thumbnailText: 'เซี่ยงไฮ้ทาวเวอร์',
    badge_unlocked_img: 'buddha',
  },
  {
    target_img: 'bund',
    thumbnailText: 'เดอะบันด์',
    badge_unlocked_img: 'shanghai',
  },
  {
    target_img: 'xintiandi',
    thumbnailText: 'ซินเทียนตี้',
    badge_unlocked_img: 'bund',
  },
];

export const CHALLENGE_12_TEAM_MAP_TARGET_BADGE_IMG = [
  {
    target_img: 'greatwall',
    thumbnailText: 'กำแพงเมืองจีน',
    badge_unlocked_img: '',
  },
  {
    target_img: 'lamatemple',
    thumbnailText: 'วัดลามะ',
    badge_unlocked_img: 'greatwall',
  },
  {
    target_img: 'tiananmen',
    thumbnailText: 'จัตุรัสเทียนอันเหมิน',
    badge_unlocked_img: 'lamatemple',
  },
  {
    target_img: 'forbiddencity',
    thumbnailText: 'พระราชวังต้องห้าม',
    badge_unlocked_img: 'tiananmen',
  },
  {
    target_img: 'yuyuantan',
    thumbnailText: 'สวนสาธารณะอวี้หยวนถาน',
    badge_unlocked_img: 'forbiddencity',
  },
  {
    target_img: 'templeofheaven',
    thumbnailText: 'หอสักการะฟ้าเทียนถาน',
    badge_unlocked_img: 'yuyuantan',
  },
];
export const CHALLENGE_MAP_LOADING = [
  { value: 50, message: 'กำลังสร้างแผนที่ให้กับคุณ' },
  { value: 95, message: 'เตรียมตัวให้พร้อม!' },
  { value: 100, message: 'ยินดีต้อนรับสู่เกมแผนที่!' },
];

export const CHALLENGE_MAP_PULLUP = {
  TAB_TOTAL_STEPS: 'ก้าวเดินสะสม',
  TAB_DAILY_STEPS: 'ก้าวเดินวันนี้',
  GREETING_TEXT: 'ขอแสดงความยินดีด้วย',
  CHALLENGE_COMPLETE_MESSAGE: 'คุณเข้าเส้นชัย และพิชิตแผนที่ทั้งหมดแล้ว!',
  STEPS_UNIT: 'ก้าว',
  DISTANCE_UNIT: 'กม.',
  CALORIE_UNIT: 'แคลอรี',
  WALK_TITLE: 'เดินอีก',
  DESTINATION: 'เพื่อไปยังจุดหมายถัดไป',
  TOTAL_TARGET: 600000,
  STEPS_INTERVAL: 100000,
  DAILY_STEPS_TARGET: 10000,
  TOTAL_MILESTONES: 6,
};

export const ALL_STEPS_BADGES = [
  'egypt',
  'peru',
  'usa',
  'france',
  'nepal',
  'japan',
];

export const ALL_STEPS_BADGES_BUDDYME = [
  'khaoyai',
  'inthanon',
  'myanmar',
  'laos',
  'cambodia',
  'vietnam',
]

export const ALL_STEPS_BADGES_CHALLENGE11 = [
  'zhujia',
  'yugarden',
  'buddha',
  'shanghai',
  'bund',
  'xintiandi'
]
export const ALL_STEPS_BADGES_ME_CHALLENGE12 = [
  'one',
  'two',
  'three',
  'four',
  'five',
  'six'
]
export const ALL_STEPS_BADGES_TEAM_CHALLENGE12 = [
  'greatwall',
  'lamatemple',
  'tiananmen',
  'forbiddencity',
  'yuyuantan',
  'templeofheaven'
]


export const OTHERS_BADGES = ['quiz', 'vdo', 'food', 'calorie'];

export const allUsersMarkerTranslateMapping = [
  ['-20px -90px'],
  ['-45px -85px', '5px -85px'],
  [
    '-60px -65px',
    '-20px -90px',
    '26px -65px',
  ],
  [
    '-55px -80px',
    '15px -80px',
    '-55px -6px',
    '16px -6px',
  ],
];

export const CHALLENGE_UNLOCKED = {
  MODAL_TITLE: 'ยินดีด้วย',
  MODAL_GREETING_TEXT: 'คุณได้พิชิต',
  MODAL_SHARE_TEXT: 'แชร:์',
  MODAL_SUBMIT_BTN: 'ดูแผนที่',
  SOCIAL_MEDIA_LIST: ['facebook', 'instagram', 'line'],
  INSTA_MESSAGE: 'No support from Instagram yet',
  SHARE_SUCCESS_MESSAGE: 'The achievement was shared successfully',
  SHARE_FAILURE_MESSAGE: 'Failed to share achievement. Something went wrong',
  UNLOCK_MESSAGE_DATE_PREFIX: 'พิชิตเหรียญนี้สำเร็จเมื่อ',
};

export const BADGE_MAPPING = [
  {
    greetingMessage: 'Pyramid of Giza',
    imgPath: 'egypt',
    goalCard: '/images/challenge/step_peru.png',
  },
  {
    greetingMessage: 'Machu Picchu',
    imgPath: 'peru',
    goalCard: '/images/challenge/step_usa.png',
  },
  {
    greetingMessage: 'Statue of Liberty',
    imgPath: 'usa',
    goalCard: '/images/challenge/step_france.png',
  },
  {
    greetingMessage: 'Eiffel Tower',
    imgPath: 'france',
    goalCard: '/images/challenge/step_nepal.png',
  },
  {
    greetingMessage: 'Mount Everest',
    imgPath: 'nepal',
    goalCard: '/images/challenge/step_japan.png',
  },
  {
    greetingMessage: 'Mount Fuji',
    imgPath: 'japan',
  },
];

export const BUDDY_ME_BADGE_MAPPING = [
  {
    greetingMessage: 'เขาใหญ่, ไทย',
    imgPath: 'khaoyai',
    goalCard: '/images/challenge/step_inthanon.png',
  },
  {
    greetingMessage: 'ดอยอินทนนท์, ไทย',
    imgPath: 'inthanon',
    goalCard: '/images/challenge/step_myanmar.png',
  },
  {
    greetingMessage: 'วังเวียง, ลาว',
    imgPath: 'myanmar',
    goalCard: '/images/challenge/step_laos.png',
  },
  {
    greetingMessage: 'พุกาม, พม่า',
    imgPath: 'laos',
    goalCard: '/images/challenge/step_cambodia.png',
  },
  {
    greetingMessage: 'นครวัด, กัมพูชา',
    imgPath: 'cambodia',
    goalCard: '/images/challenge/step_vietnam.png',
  },
  {
    greetingMessage: 'บาน่าฮิลล์, เวียดนาม',
    imgPath: 'vietnam',
  },
];

export const CHALLENGE_11_TEAM_BADGE_MAPPING = [
  {
    greetingMessage: 'เมืองน้ำโบราณจูเจียเจี่ยว, จีน',
    imgPath: 'zhujia',
    goalCard: '/images/challenge/step_yugarden.png',
    targetMessage: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
  },
  {
    greetingMessage: 'สวนอี้หยวน, จีน',
    imgPath: 'yugarden',
    goalCard: '/images/challenge/step_buddha.png',
    targetMessage: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
  },
  {
    greetingMessage: 'วัดพระหยกขาว, จีน',
    imgPath: 'buddha',
    goalCard: '/images/challenge/step_shanghai.png',
    targetMessage: 'สวนอี้หยวน, เซี่ยงไฮ้',
  },
  {
    greetingMessage: 'เซี่ยงไฮ้ทาวเวอร์, จีน',
    imgPath: 'shanghai',
    goalCard: '/images/challenge/step_bund.png',
    targetMessage: 'วัดพระหยกขาว, เซี่ยงไฮ้',
  },
  {
    greetingMessage: 'เดอะบันด์, จีน',
    imgPath: 'bund',
    goalCard: '/images/challenge/step_xintiandi.png',
    targetMessage: 'เซี่ยงไฮ้ทาวเวอร์, เซี่ยงไฮ้',
  },
  {
    greetingMessage: 'ซินเทียนตี้, จีน',
    imgPath: 'xintiandi',
    targetMessage: 'เดอะบันด์, เซี่ยงไฮ้',
  },
];

export const CHALLENGE_12_TEAM_BADGE_MAPPING = [
    {
    greetingMessage: 'กำแพงเมืองจีน, จีน',
    imgPath: 'greatwall',
    goalCard: '/images/challenge/step_lamatemple.png',
    targetMessage: 'กำแพงเมืองจีน',
  },
  {
    greetingMessage: 'วัดลามะ, จีน',
    imgPath: 'lamatemple',
    goalCard: '/images/challenge/step_tiananmen.png',
    targetMessage: 'วัดลามะ',
  },
  {
    greetingMessage: 'จัตุรัสเทียนอันเหมิน, จีน',
    imgPath: 'tiananmen',
    goalCard: '/images/challenge/step_forbiddencity.png',
    targetMessage: 'จัตุรัสเทียนอันเหมิน',
  },
  {
    greetingMessage: 'พระราชวังต้องห้าม, จีน',
    imgPath: 'forbiddencity',
    goalCard: '/images/challenge/step_yuyuantan.png',
    targetMessage: 'พระราชวังต้องห้าม',
  },
  {
    greetingMessage: 'สวนสาธารณะอวี้หยวนถาน, จีน',
    imgPath: 'yuyuantan',
    goalCard: '/images/challenge/step_templeofheaven.png',
    targetMessage: 'สวนสาธารณะอวี้หยวนถาน',
  },
  {
    greetingMessage: 'หอสักการะฟ้าเทียนถาน, จีน',
    imgPath: 'templeofheaven',
    targetMessage: 'หอสักการะฟ้าเทียนถาน',
  },
]

export const CHALLENGE_MAP_DETAIL = {
  defaultPaddingTop: 500,
  maxPaddingTop: 868,
  minPaddingTop: 220,
  HOME_TABS_LIST: ['สถานที่', 'อันดับ'],
};
export const LINE_REGISTER_STATUS = 'complete';

export const PERSONAL_MEMBER_PICTURE = {
  PREVIEW_SUCCESS_BTN: 'ยืนยัน',
  PREVIEW_RETAKE_BTN: 'อัปโหลดภาพใหม่',
  BEFORE_THAI: 'ก่อนการแข่งขัน',
  AFTER_THAI: 'หลังการแข่งขัน',
  BEFORE_SUB_THAI: 'อัปโหลดได้ ตั้งแต่วันที่ 1-67 ของการแข่งขัน',
  AFTER_SUB_THAI: 'ระบบเปิดให้อัปโหลดได้ ตั้งแต่วันที่ 61-67 ของการแข่งเขัน',
  BEFORE_AND_AFTER_PICTURES_TITLE: 'ภาพก่อน - หลัง',
  BODY_PICTURE_BEFORE_AND_AFTER_TITLE: 'ภาพถ่าย',
  FRONT_TITLE: 'ด้านหน้า',
  LEFTSIDE_TITLE: 'ด้านซ้าย',
  RIGHTSIDE_TITLE: 'ด้านขวา',
  GREY_OUT_BACK: 'หลัง',
  GREY_OUT_OVERDUE: 'หลัง',
};

export const PERSONAL_MEMBER_PICTURE_MAP = {
  BEFORE_CENTER: 'ภาพด้านหน้า (ก่อน)',
  BEFORE_LEFT: 'ภาพด้านซ้าย (ก่อน)',
  BEFORE_RIGHT: 'ภาพด้านขวา (ก่อน)',
  AFTER_CENTER: 'ภาพด้านหน้า (หลัง)',
  AFTER_LEFT: 'ภาพด้านซ้าย (หลัง)',
  AFTER_RIGHT: 'ภาพด้านขวา (หลัง)',
};
export const BADGE_ACTIVE_ICON =
  '/images/challenge/icons/icon-rect-badge_active.svg';

export const BMI_ICON_MAPPING = {
  low: {
    title: 'ต่ำกว่าเกณฑ์',
    icon: variables.bmiLowText,
    classname: 'bmi-low',
  },
  normal: {
    title: 'เกณฑ์ปกติ',
    icon: variables.bmiNormalText,
    classname: 'bmi-normal',
  },
  firstLevelFat: {
    title: 'อ้วนระดับ 1',
    icon: variables.bmiFat1Text,
    classname: 'bmi-fat-1',
  },
  secondLevelFat: {
    title: 'อ้วนระดับ 2',
    icon: variables.bmiFat2Text,
    classname: 'bmi-fat-2',
  },
  thirdLevelFat: {
    title: 'อ้วนระดับ 3',
    icon: variables.bmiFat3Text,
    classname: 'bmi-fat-3',
  },
};

export const WEIGHT_IN_OUT_BUTTONS = ['ชั่งก่อนการแข่งขัน', 'ชั่งจบการแข่งขัน'];

export const WEIGHT_FAT_MUSCLE_MAPPING = {
  increase: {
    classname: 'weight-fat-inc',
  },
  decrease: {
    classname: 'weight-fat-dec',
  },
  muscleInc: {
    classname: 'muscle-inc',
  },
  //TODO: Change icon of weight decrease
  muscleDec: {
    classname: 'muscle-dec',
  },
};

export const ALL_BADGES_IMAGES = [
  {
    imageUrl: '/images/challenge/badges/steps-egypt_disable-badge@5x.png',
    title: 'Pyramid of Giza',
    id: 'egypt',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  {
    imageUrl: '/images/challenge/badges/steps-peru_disable-badge@5x.png',
    title: 'Machu Picchu',
    id: 'peru',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  {
    imageUrl: '/images/challenge/badges/steps-usa_disable-badge@5x.png',
    title: 'Statue of Liberty',
    id: 'usa',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  {
    imageUrl: '/images/challenge/badges/steps-france_disable-badge@5x.png',
    title: 'Eiffel Tower',
    id: 'france',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  {
    imageUrl: '/images/challenge/badges/steps-nepal_disable-badge@5x.png',
    title: 'Mount Everest',
    id: 'nepal',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  {
    imageUrl: '/images/challenge/badges/steps-japan_disable-badge@5x.png',
    title: 'Mount Fuji',
    id: 'japan',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
];

export const MISSION_SECTION_BADGES = [
  {
    imageUrl: '/images/challenge/badges/food_disable-badge@5x.png',
    title: 'The Best Discipliner',
    id: 'best-discipliner',
    type: 'food',
    maxValueOfBadge: 60,
  },
  {
    imageUrl: '/images/challenge/badges/vdo_disable-badge@5x.png',
    title: 'The Best Learner',
    id: 'best-learner',
    type: 'vdo',
    maxValueOfBadge: 60,
  },
  {
    imageUrl: '/images/challenge/badges/quiz_disable-badge@5x.png',
    title: 'Top Learner',
    id: 'top-learner',
    type: 'quiz',
    maxValueOfBadge: 60,
  },
  {
    imageUrl: '/images/challenge/badges/calorie_disable-badge@5x.png',
    title: 'The Goal Keeper',
    id: 'goal-keeper',
    type: 'calorie',
    maxValueOfBadge: 60,
  },
];

export const VIDEO_CARD_TEXT = {
  duration_text: 'นาที',
  video_title: 'Title',
  video_detail_heading: 'วิดีโอทั้งหมด',
  play_icon_url: '/images/challenge/play-sm.svg',
};

export const BADGES_MILESTONE = {
  badge1: 'egypt',
  badge2: 'peru',
  badge3: 'usa',
  badge4: 'france',
  badge5: 'nepal',
  badge6: 'japan',
};

export const BUDDY_ME_BADGES_MILESTONE = {
  badge1: 'khaoyai',
  badge2: 'inthanon',
  badge3: 'myanmar',
  badge4: 'laos',
  badge5: 'cambodia',
  badge6: 'vietnam',
};

export const CHALLENGE_11_BADGES_MILESTONE = {
  badge1: 'zhujia',
  badge2: 'yugarden',
  badge3: 'buddha',
  badge4: 'shanghai',
  badge5: 'bund',
  badge6: 'xintiandi',
};

export const CHALLENGE_12_TEAM_BADGES_MILESTONE = {
  badge1: 'greatwall',
  badge2: 'lamatemple',
  badge3: 'tiananmen',
  badge4: 'forbiddencity',
  badge5: 'yuyuantan',
  badge6: 'templeofheaven',
};

export const CHALLENGE_ME_BADGES_MILESTONE = {
  badge1: 'one',
  badge2: 'two',
  badge3: 'three',
  badge4: 'four',
  badge5: 'five',
  badge6: 'six',
};

export const minContent = '0';
export const maxTeamSteps = '20,000';
export const maxFoodVdoCalorieBadges = 60;
export const maxQuizBadges = 60;

export const USER_OR_TEAM_MEDALS = ['เหรียญของฉัน', 'เหรียญของทีม'];

export const CHALLENGE_USER_DEFAULT_IMG =
  '/images/challenge/icons/team-dashboard-no-user.svg';

export const CHALLENGE_MAP_DETAIL_MAPPING = {
  egypt: {
    badge_icon: '/images/challenge/badge-egypt.svg',
    bg_image: '/images/challenge/egypt-detail.svg',
    title: 'ปิรามิดแห่งกีซ่า, อียิปต์',
    mapDetailTitle: 'ปิรามิดแห่งกีซ่า, อียิปต์',
    initialY: -100,
    enTitle: 'Pyramid of Giza',
    thTitle: 'เขาใหญ่',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  peru: {
    badge_icon: '/images/challenge/badge-peru.svg',
    bg_image: '/images/challenge/peru-detail.svg',
    title: 'มาชูปิกชู, เปรู',
    mapDetailTitle: 'มาชูปิกชู, เปรู',
    initialY: -100,
    enTitle: 'Machu Pichu',
    thTitle: 'ดอยอินทนนท์',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  usa: {
    badge_icon: '/images/challenge/badge-usa.svg',
    bg_image: '/images/challenge/usa-detail.svg',
    title: 'อนุสาวรีย์เทพีเสรีภาพ, สหรัฐอเมริกา',
    mapDetailTitle: 'อนุสาวรีย์เทพีเสรีภาพ, สหรัฐอเมริกา',
    initialY: 0,
    enTitle: 'Statue of Liberty',
    thTitle: 'เมียนมาร์',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  france: {
    badge_icon: '/images/challenge/badge-france.svg',
    bg_image: '/images/challenge/france-detail.svg',
    title: 'หอไอเฟล, ฝรั่งเศส',
    mapDetailTitle: 'หอไอเฟล, ฝรั่งเศส',
    initialY: -75,
    enTitle: 'Eiffel Tower',
    thTitle: 'ลาว',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  nepal: {
    badge_icon: '/images/challenge/badge-nepal.svg',
    bg_image: '/images/challenge/nepal-detail.svg',
    title: 'ยอดเขาเอเวอเรสต์, เนปาล',
    mapDetailTitle: 'ยอดเขาเอเวอเรสต์, เนปาล',
    initialY: -100,
    enTitle: 'Mount Everest',
    thTitle: 'กัมพูชา',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  japan: {
    badge_icon: '/images/challenge/badge-japan.svg',
    bg_image: '/images/challenge/japan-detail.svg',
    title: 'ภูเขาไฟฟูจิ, ญี่ปุ่น',
    mapDetailTitle: 'ภูเขาไฟฟูจิ, ญี่ปุ่น',
    initialY: -100,
    enTitle: 'Mount Fuji',
    thTitle: 'เวียดนาม',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
  egypt_disable: {
    badge_icon: '/images/challenge/badge-egypt.svg',
    bg_image: '/images/challenge/egypt-detail.svg',
    title: 'ปิรามิดแห่งกีซ่า, อียิปต์',
    mapDetailTitle: 'ปิรามิดแห่งกีซ่า, อียิปต์',
    initialY: -100,
    enTitle: 'Pyramid of Giza',
    thTitle: 'เขาใหญ่',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  peru_disable: {
    badge_icon: '/images/challenge/badge-peru.svg',
    bg_image: '/images/challenge/peru-detail.svg',
    title: 'มาชูปิกชู, เปรู',
    mapDetailTitle: 'มาชูปิกชู, เปรู',
    initialY: -100,
    enTitle: 'Machu Pichu',
    thTitle: 'ดอยอินทนนท์',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  usa_disable: {
    badge_icon: '/images/challenge/badge-usa.svg',
    bg_image: '/images/challenge/usa-detail.svg',
    title: 'อนุสาวรีย์เทพีเสรีภาพ, สหรัฐอเมริกา',
    mapDetailTitle: 'อนุสาวรีย์เทพีเสรีภาพ, สหรัฐอเมริกา',
    initialY: 0,
    enTitle: 'Statue of Liberty',
    thTitle: 'เมียนมาร์',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  france_disable: {
    badge_icon: '/images/challenge/badge-france.svg',
    bg_image: '/images/challenge/france-detail.svg',
    title: 'หอไอเฟล, ฝรั่งเศส',
    mapDetailTitle: 'หอไอเฟล, ฝรั่งเศส',
    initialY: -75,
    enTitle: 'Eiffel Tower',
    thTitle: 'ลาว',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  nepal_disable: {
    badge_icon: '/images/challenge/badge-nepal.svg',
    bg_image: '/images/challenge/nepal-detail.svg',
    title: 'ยอดเขาเอเวอเรสต์, เนปาล',
    mapDetailTitle: 'ยอดเขาเอเวอเรสต์, เนปาล',
    initialY: -100,
    enTitle: 'Mount Everest',
    thTitle: 'กัมพูชา',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  japan_disable: {
    badge_icon: '/images/challenge/badge-japan.svg',
    bg_image: '/images/challenge/japan-detail.svg',
    title: 'ภูเขาไฟฟูจิ, ญี่ปุ่น',
    mapDetailTitle: 'ภูเขาไฟฟูจิ, ญี่ปุ่น',
    initialY: -100,
    enTitle: 'Mount Fuji',
    thTitle: 'เวียดนาม',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
};

export const BUDDY_ME_MAP_DETAIL_MAPPING = {
  khaoyai: {
    bg_image: '/images/challenge/khaoyai-detail.svg',
    title: 'อุทยานแห่งชาติเขาใหญ่',
    mapDetailTitle: 'เขาใหญ่, ไทย',
    initialY: -100,
    enTitle: 'Khao Yai National Park',
    thTitle: 'เขาใหญ่',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  inthanon: {
    bg_image: '/images/challenge/inthanon-detail.svg',
    title: 'อุทยานแห่งชาติ\nดอยอินทนนท์',
    mapDetailTitle: 'ดอยอินทนนท์, ไทย',
    initialY: -100,
    enTitle: 'Doi Inthanon National Park',
    thTitle: 'ดอยอินทนนท์',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  myanmar: {
    bg_image: '/images/challenge/myanmar-detail.svg',
    title: 'พุกาม - เมียนมา',
    mapDetailTitle: 'พุกาม, เมียนมาร์',
    initialY: 0,
    enTitle: 'Bagan - Myannmar',
    thTitle: 'เมียนมาร์',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  laos: {
    bg_image: '/images/challenge/laos-detail.svg',
    title: 'วังเวียง - ลาว',
    mapDetailTitle: 'วังเวียง, ลาว',
    initialY: -75,
    enTitle: 'Vang Vieng - Laos',
    thTitle: 'ลาว',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  cambodia: {
    bg_image: '/images/challenge/cambodia-detail.svg',
    title: 'นครวัด - กัมพูชา',
    mapDetailTitle: 'นครวัด, กัมพูชา',
    initialY: -100,
    enTitle: 'Angkor Wat - Cambodia',
    thTitle: 'กัมพูชา',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  vietnam: {
    bg_image: '/images/challenge/vietnam-detail.svg',
    title: 'บาน่าฮิลล์ - เวียดนาม',
    mapDetailTitle: 'BodyKey Me & Buddy Challenge',
    initialY: -100,
    enTitle: 'Bana Hills - Vietnam',
    thTitle: 'เวียดนาม',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
  khaoyai_disable: {
    badge_icon: '/images/challenge/badge-egypt.svg',
    bg_image: '/images/challenge/egypt-detail.svg',
    title: 'อุทยานแห่งชาติเขาใหญ่',
    mapDetailTitle: 'เขาใหญ่, ไทย',
    initialY: -100,
    enTitle: 'Khao Yai National Park',
    thTitle: 'เขาใหญ่',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  inthanon_disable: {
    badge_icon: '/images/challenge/badge-peru.svg',
    bg_image: '/images/challenge/peru-detail.svg',
    title: 'อุทยานแห่งชาติ\nดอยอินทนนท์',
    mapDetailTitle: 'ดอยอินทนนท์, ไทย',
    initialY: -100,
    enTitle: 'Doi Inthanon National Park',
    thTitle: 'ดอยอินทนนท์',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  myanmar_disable: {
    badge_icon: '/images/challenge/badge-usa.svg',
    bg_image: '/images/challenge/usa-detail.svg',
    title: 'พุกาม - เมียนมา',
    mapDetailTitle: 'พุกาม, เมียนมาร์',
    initialY: 0,
    enTitle: 'Bagan - Myannmar',
    thTitle: 'เมียนมาร์',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  laos_disable: {
    badge_icon: '/images/challenge/badge-france.svg',
    bg_image: '/images/challenge/france-detail.svg',
    title: 'วังเวียง - ลาว',
    mapDetailTitle: 'วังเวียง, ลาว',
    initialY: -75,
    enTitle: 'Vang Vieng - Laos',
    thTitle: 'ลาว',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  cambodia_disable: {
    badge_icon: '/images/challenge/badge-nepal.svg',
    bg_image: '/images/challenge/nepal-detail.svg',
    title: 'นครวัด - กัมพูชา',
    mapDetailTitle: 'นครวัด, กัมพูชา',
    initialY: -100,
    enTitle: 'Angkor Wat - Cambodia',
    thTitle: 'กัมพูชา',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  vietnam_disable: {
    badge_icon: '/images/challenge/badge-japan.svg',
    bg_image: '/images/challenge/japan-detail.svg',
    title: 'บาน่าฮิลล์ - เวียดนาม',
    mapDetailTitle: 'BodyKey Me & Buddy Challenge',
    initialY: -100,
    enTitle: 'Bana Hills - Vietnam',
    thTitle: 'เวียดนาม',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
};

export const CHALLENGE_ME_12_MAP_DETAIL_MAPPING = {
  one: {
    bg_image: '/images/challenge/zhujia-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
    initialY: -20,
    enTitle: '100K Steps',
    thTitle: '100K Steps',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  two: {
    bg_image: '/images/challenge/yugarden-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'สวนอี้หยวน, เซี่ยงไฮ้',
    initialY: 0,
    enTitle: '200K Steps',
    thTitle: '200K Steps',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  three: {
    bg_image: '/images/challenge/buddha-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'วัดพระหยกขาว, เซี่ยงไฮ้',
    initialY: -15,
    enTitle: '300K Steps',
    thTitle: '300K Steps',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  four: {
    bg_image: '/images/challenge/shanghai-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เซี่ยงไฮ้ทาวเวอร์, เซี่ยงไฮ้',
    initialY: -10,
    enTitle: '400K Steps',
    thTitle: '400K Steps',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  five: {
    bg_image: '/images/challenge/bund-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เดอะบันด์, เซี่ยงไฮ้',
    initialY: -10,
    enTitle: '500K Steps',
    thTitle: '500K Steps',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  six: {
    bg_image: '/images/challenge/xintiandi-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'ซินเทียนตี้, เซี่ยงไฮ้',
    initialY: -20,
    enTitle: '600K Steps',
    thTitle: '600K Steps',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
  one_disable: {
    badge_icon: '/images/challenge/badge-zhujia.svg',
    bg_image: '/images/challenge/zhujia-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: '100K Steps',
    thTitle: '100K Steps',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  two_disable: {
    badge_icon: '/images/challenge/badge-yugarden.svg',
    bg_image: '/images/challenge/yugarden-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'สวนอี้หยวน, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: '200K Steps',
    thTitle: '200K Steps',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  three_disable: {
    badge_icon: '/images/challenge/badge-buddha.svg',
    bg_image: '/images/challenge/buddha-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'วัดพระหยกขาว, เซี่ยงไฮ้',
    initialY: 0,
    enTitle: '300K Steps',
    thTitle: '300K Steps',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  four_disable: {
    badge_icon: '/images/challenge/badge-shanghai.svg',
    bg_image: '/images/challenge/shanghai-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เซี่ยงไฮ้ทาวเวอร์, เซี่ยงไฮ้',
    initialY: -75,
    enTitle: '400K Steps',
    thTitle: '400K Steps',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  five_disable: {
    badge_icon: '/images/challenge/badge-bund.svg',
    bg_image: '/images/challenge/bund-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'เดอะบันด์, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: '500K Steps',
    thTitle: '500K Steps',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  six_disable: {
    badge_icon: '/images/challenge/badge-xintiandi.svg',
    bg_image: '/images/challenge/xintiandi-detail.svg',
    title: 'เหรียญรางวัลความสำเร็จ',
    mapDetailTitle: 'ซินเทียนตี้, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: '600K Steps',
    thTitle: '600K Steps',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
};

export const CHALLENGE_12_TEAM_MAP_DETAIL_MAPPING = {
  greatwall: {
    bg_image: '/images/challenge/greatwall-detail.svg',
    title: 'กำแพงเมืองจีน',
    mapDetailTitle: 'กำแพงเมืองจีน',
    initialY: -5,
    enTitle: 'Great Wall of China', 
    thTitle: 'กำแพงเมืองจีน',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  lamatemple: {
    bg_image: '/images/challenge/lamatemple-detail.svg',
    title: 'วัดลามะ',
    mapDetailTitle: 'วัดลามะ',
    initialY: -5,
    enTitle: 'Lama Temple',
    thTitle: 'วัดลามะ',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  tiananmen: {
    bg_image: '/images/challenge/tiananmen-detail.svg',
    title: 'จัตุรัสเทียนอันเหมิน',
    mapDetailTitle: 'จัตุรัสเทียนอันเหมิน',
    initialY: -5,
    enTitle: 'Tiananmen Square',
    thTitle: 'จัตุรัสเทียนอันเหมิน',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  forbiddencity: {
    bg_image: '/images/challenge/forbiddencity-detail.svg',
    title: 'พระราชวังต้องห้าม',
    mapDetailTitle: 'พระราชวังต้องห้าม',
    initialY: -5,
    enTitle: 'The Forbidden City',
    thTitle: 'พระราชวังต้องห้าม',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  yuyuantan: {
    bg_image: '/images/challenge/yuyuantan-detail.svg',
    title: 'สวนสาธารณะอวี้หยวนถาน',
    mapDetailTitle: 'สวนสาธารณะอวี้หยวนถาน',
    initialY: -5,
    enTitle: 'Yuyuantan Park',
    thTitle: 'สวนสาธารณะอวี้หยวนถาน',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  templeofheaven: {
    bg_image: '/images/challenge/templeofheaven-detail.svg',
    title: 'หอสักการะฟ้าเทียนถาน',
    mapDetailTitle: 'หอสักการะฟ้าเทียนถาน',
    initialY: 0,
    enTitle: 'Temple of Heaven',
    thTitle: 'หอสักการะฟ้าเทียนถาน',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
  greatwall_disable: {
    bg_image: '/images/challenge/greatwall-detail.svg',
    title: 'กำแพงเมืองจีน',
    mapDetailTitle: 'กำแพงเมืองจีน',
    initialY: -20,
    enTitle: 'Great Wall of China',
    thTitle: 'กำแพงเมืองจีน',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  lamatemple_disable: {
    bg_image: '/images/challenge/lamatemple-detail.svg',
    title: 'วัดลามะ',
    mapDetailTitle: 'วัดลามะ',
    initialY: 0,
    enTitle: 'Lama Temple',
    thTitle: 'วัดลามะ',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  tiananmen_disable: {
    bg_image: '/images/challenge/tiananmen-detail.svg',
    title: 'จัตุรัสเทียน อันเหมิน',
    mapDetailTitle: 'จัตุรัสเทียน อันเหมิน',
    initialY: -15,
    enTitle: 'Tiananmen Square',
    thTitle: 'จัตุรัสเทียน อันเหมิน',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  forbiddencity_disable: {
    bg_image: '/images/challenge/forbiddencity-detail.svg',
    title: 'พระราชวัง ต้องห้าม',
    mapDetailTitle: 'พระราชวัง ต้องห้าม',
    initialY: -10,
    enTitle: 'The Forbidden City',
    thTitle: 'พระราชวัง ต้องห้าม',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  yuyuantan_disable: {
    bg_image: '/images/challenge/yuyuantan-detail.svg',
    title: 'สวนสาธารณะอวี้หยวนถาน',
    mapDetailTitle: 'สวนสาธารณะอวี้หยวนถาน',
    initialY: -10,
    enTitle: 'Yuyuantan Park',
    thTitle: 'สวนสาธารณะอวี้หยวนถาน',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  templeofheaven_disable: {
    bg_image: '/images/challenge/templeofheaven-detail.svg',
    title: 'หอสักการะ ฟ้าเทียนถาน',
    mapDetailTitle: 'หอสักการะ ฟ้าเทียนถาน',
    initialY: -20,
    enTitle: 'Temple of Heaven',
    thTitle: 'หอสักการะ ฟ้าเทียนถาน',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
};

export const CHALLENGE_11_MAP_DETAIL_MAPPING = {
  zhujia: {
    bg_image: '/images/challenge/zhujia-detail.svg',
    title: 'เมืองน้ำโบราณจูเจียเจี่ยว',
    mapDetailTitle: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
    initialY: -20,
    enTitle: 'Khao Yai National Park',
    thTitle: 'จูเจียเจี่ยว',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  yugarden: {
    bg_image: '/images/challenge/yugarden-detail.svg',
    title: 'สวนอี้หยวน',
    mapDetailTitle: 'สวนอี้หยวน, เซี่ยงไฮ้',
    initialY: 0,
    enTitle: 'Doi Inthanon National Park',
    thTitle: 'สวนอี้หยวน',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  buddha: {
    bg_image: '/images/challenge/buddha-detail.svg',
    title: 'วัดพระหยกขาว',
    mapDetailTitle: 'วัดพระหยกขาว, เซี่ยงไฮ้',
    initialY: -15,
    enTitle: 'Bagan - Myannmar',
    thTitle: 'วัดพระหยกขาว',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  shanghai: {
    bg_image: '/images/challenge/shanghai-detail.svg',
    title: 'เซี่ยงไฮ้ทาวเวอร์',
    mapDetailTitle: 'เซี่ยงไฮ้ทาวเวอร์, เซี่ยงไฮ้',
    initialY: -10,
    enTitle: 'Vang Vieng - Laos',
    thTitle: 'เซี่ยงไฮ้ทาวเวอร์',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  bund: {
    bg_image: '/images/challenge/bund-detail.svg',
    title: 'เดอะบันด์',
    mapDetailTitle: 'เดอะบันด์, เซี่ยงไฮ้',
    initialY: -10,
    enTitle: 'Angkor Wat - Cambodia',
    thTitle: 'เดอะบันด์',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  xintiandi: {
    bg_image: '/images/challenge/xintiandi-detail.svg',
    title: 'ซินเทียนตี้',
    mapDetailTitle: 'ซินเทียนตี้, เซี่ยงไฮ้',
    initialY: -20,
    enTitle: 'Bana Hills - Vietnam',
    thTitle: 'ซินเทียนตี้',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
  zhujia_disable: {
    badge_icon: '/images/challenge/badge-zhujia.svg',
    bg_image: '/images/challenge/zhujia-detail.svg',
    title: 'เมืองน้ำโบราณจูเจียเจี่ยว',
    mapDetailTitle: 'เมืองน้ำโบราณจูเจียเจี่ยว, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: 'Khao Yai National Park',
    thTitle: 'จูเจียเจี่ยว',
    maxValueOfBadge: 100000,
    minValueOfBadge: 0,
  },
  yugarden_disable: {
    badge_icon: '/images/challenge/badge-yugarden.svg',
    bg_image: '/images/challenge/yugarden-detail.svg',
    title: 'สวนอี้หยวน',
    mapDetailTitle: 'สวนอี้หยวน, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: 'Doi Inthanon National Park',
    thTitle: 'สวนอี้หยวน',
    maxValueOfBadge: 200000,
    minValueOfBadge: 100000,
  },
  buddha_disable: {
    badge_icon: '/images/challenge/badge-buddha.svg',
    bg_image: '/images/challenge/buddha-detail.svg',
    title: 'วัดพระหยกขาว',
    mapDetailTitle: 'วัดพระหยกขาว, เซี่ยงไฮ้',
    initialY: 0,
    enTitle: 'Bagan - Myannmar',
    thTitle: 'วัดพระหยกขาว',
    maxValueOfBadge: 300000,
    minValueOfBadge: 200000,
  },
  shanghai_disable: {
    badge_icon: '/images/challenge/badge-shanghai.svg',
    bg_image: '/images/challenge/shanghai-detail.svg',
    title: 'เซี่ยงไฮ้ทาวเวอร์',
    mapDetailTitle: 'เซี่ยงไฮ้ทาวเวอร์, เซี่ยงไฮ้',
    initialY: -75,
    enTitle: 'Vang Vieng - Laos',
    thTitle: 'เซี่ยงไฮ้ทาวเวอร์',
    maxValueOfBadge: 400000,
    minValueOfBadge: 300000,
  },
  bund_disable: {
    badge_icon: '/images/challenge/badge-bund.svg',
    bg_image: '/images/challenge/bund-detail.svg',
    title: 'เดอะบันด์',
    mapDetailTitle: 'เดอะบันด์, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: 'Angkor Wat - Cambodia',
    thTitle: 'เดอะบันด์',
    maxValueOfBadge: 500000,
    minValueOfBadge: 400000,
  },
  xintiandi_disable: {
    badge_icon: '/images/challenge/badge-xintiandi.svg',
    bg_image: '/images/challenge/xintiandi-detail.svg',
    title: 'ซินเทียนตี้',
    mapDetailTitle: 'ซินเทียนตี้, เซี่ยงไฮ้',
    initialY: -100,
    enTitle: 'Bana Hills - Vietnam',
    thTitle: 'ซินเทียนตี้',
    maxValueOfBadge: 600000,
    minValueOfBadge: 500000,
  },
};

export const CHALLENGE_MILESTONE = 'milestone';
export const CHALLENGE_MILESTONE_PERU = 'peru';
export const CHALLENGE_MAP_SLIDER = {
  sliderMinHeight: 10,
  sliderMaxHeight: 700,
  sliderDefaultHeight: 400,
  sliderAutoHeight: 'auto',
};

export const REWARD_HEADER = {
  LEFT_ICON: '/images/challenge/challenge-home.svg',
  RIGHT_ICON: '/images/challenge/team-dashboard.svg',
};

export const CHALLENGE_REWARD_DETAIL = {
  HOME_TABS_LIST: ['รางวัลของฉัน', 'รางวัลของทีม'],
};
export const CAROUSEL_CARD_DATES = {
  upcoming: {
    beforeReg: 'เปิดรับสมัคร',
    duringReg: 'สมัครภายใน',
  },
  ongoing: {
    notStarted: 'เพิ่มสมาชิกภายใน',
    readyToStart: 'เตรียมตัวแข่งขัน',
    endChallenge: 'แข่งจบแล้ว',
    weightEnd: 'ชั่งจบภายใน',
    rewardPeriod: 'รับรางวัลภายใน',
    removeTeam: 'การแข่งขันสิ้นสุด',
    days: 'เหลืออีก',
    left: 'วัน',
    started: 'วันที่แข่งขัน',
    begin_endChallenge: 'อัปเดท Health score ภายใน:'
  },
  daysLeft: (days) => `เหลืออีก ${days} วัน`,
};
export const BEGIN_MEMBER_SCORE_TARGET = 300;
export const BEGIN_MEMBER_PASS_SCORE = 200;
export const BEFORE_TYPE = 'before';
export const AFTER_TYPE = 'after';
export const PHOTOS_LIST = ['center', 'left', 'right'];
export const PHOTOS_LIST_PAGE = [
  {
    // อัปโหลดภาพด้านหน้า
    image: (disable = '') => `/images/challenge/myupload/photo_center${disable}_icon.svg`,
    thaiLabel: 'ด้านหน้า',
    uploadPictureThai: 'อัปโหลดภาพ',
    positionImageThai: 'ด้านหน้า',
    beforeAndAfter: [
      {
        position: 'center',
        type: 'before',
        typeThai: 'ก่อน',
      },
      {
        position: 'center',
        type: 'after',
        typeThai: 'หลัง',
      },
    ],
  },
  {
    image: (disable = '') => `/images/challenge/myupload/photo_left${disable}_icon.svg`,
    thaiLabel: 'ด้านซ้าย',
    uploadPictureThai: 'อัปโหลดภาพ',
    positionImageThai: 'ด้านซ้าย',
    beforeAndAfter: [
      {
        position: 'left',
        type: 'before',
        typeThai: 'ก่อน',
      },
      {
        position: 'left',
        type: 'after',
        typeThai: 'หลัง',
      },
    ],
  },
  {
    image: (disable = '') => `/images/challenge/myupload/photo_right${disable}_icon.svg`,
    thaiLabel: 'ด้านขวา',
    uploadPictureThai: 'อัปโหลดภาพ',
    positionImageThai: 'ด้านขวา',
    beforeAndAfter: [
      {
        position: 'right',
        type: 'before',
        typeThai: 'ก่อน',
      },
      {
        position: 'right',
        type: 'after',
        typeThai: 'หลัง',
      },
    ],
  },
];

export const PICTURE_BEFORE_AFTER_SCREEN_TITLE = 'ภาพก่อน - หลัง';
export const PICTURE_BEFORE_AFTER_TITLE = 'ภาพร่างกาย';
export const PICTURE_BEFORE_TITLE = 'ก่อน';
export const PICTURE_AFTER_TITLE = 'หลัง';

export const PICTURE_TYPE_LOCALSTORAGE = 'picture_type';
export const REDIRECTION_URI = 'redirect_to_source_page';
export const IMAGE_UPLOAD_PROPS = 'image_upload_props';
export const IMAGE_UPLOAD_ID = 'image_upload_id';
export const CHALLENGE_30_IMAGES = 'CHALLENGE_30_IMAGES';

export const getPhotoName = (type, position) => `${type}_${position}`;
export const CHALLENGE_BODY_CARD = {
  HOME_TABS_LIST: ['ชั่งก่อนการแข่งขัน', 'ชั่งจบการแข่งขัน'],
};

export const DASHBOARD_HEADER = {
  LEFT_ICON: '/images/challenge/challenge-home.svg',
  RIGHT_ICON: '/images/challenge/team-dashboard.svg',
};

export const AS_BODY_KEY_VERIFICATION_STEP = "AS_BODY_KEY_VERIFICATION_STEP"
export const AS_OTP_VERIFICATION_STEP = "AS_OTP_VERIFICATION_STEP"

export const stepsBadgesRange = 100000;
export const CHUNK_SIZE = 50;
export const ARROW_WHITE_ICON = '/images/challenge/arrow-white.svg';

export const contentRegEx = /<\/?[a-z][\s\S]*>/i;

export const AUTO_SYNC_MODAL_THAI = {
  TITLE: 'ระบุเบอร์มือถือที่ใช้บน Bodykey App',
  OTP_TITLE: 'ยืนยันรหัส OTP',
  OTP_FAIL_TITLE: 'หมายเลข OTP ไม่ถูกต้อง',
  SUPPORT_CUSTOMER: [
    'เมื่อยืนยันแล้ว จะไม่สามารถแก้ไขได้',
    'กรุณาติดต่อ Amway Contact Center',
    'หากต้องการแก้ไข',
  ],
  INVALID_PHONE: [
    'ขออภัย เราไม่พบหมายเลขนี้',
    'บน Bodykey App',
    'กรุณาตรวจสอบและลองใหม่อีกครั้ง',
    'ไม่สามารถส่ง OTP ไปยังหมายเลขนี้ได้'],
  NO_FOUND_SUPPORT_CUSTOMER: [
    'ขออภัย เราไม่พบหมายเลขนี้',
    'บน Bodykey App',
    'กรุณาตรวจสอบและลองใหม่อีกครั้ง'
  ],
  IN_USE_SUPPORT_CUSTOMER: [
    'ขออภัย มีการเชื่อมต่อก้าวเดินกับ',
    'หมายเลขนี้ บน Bodykey App แล้ว',
    'กรุณาตรวจสอบและลองใหม่อีกครั้ง'
  ],
  NUMBER_ALREADY_REGISTERED_ERROR: [
    'เมื่อยืนยันแล้ว จะไม่สามารถแก้ไขได้',
    'กรุณาติดต่อ Amway Contact Center',
    'หากต้องการแก้ไข',
    'หมายเลขที่ระบุ มีการลงทะเบียนใช้งานไว้แล้ว'
  ],
  OTP_DETAIL: (bodyKeyId) => [
    'OTP จะถูกส่งไปยัง',
    bodyKeyId,
    'เบอร์โทรศัพท์ที่ทำการลงทะเบียนเอาไว้'
  ],
  OTP_FAIL_DETAIL: (bodyKeyId) => [
    'OTP จะถูกส่งไปยัง',
    bodyKeyId,
    'เบอร์โทรศัพท์ที่ทำการลงทะเบียนเอาไว้',
    'รหัส OTP ที่กรอกไม่ถูกต้อง'
  ],
  CANCEL_BTN: 'ยกเลิก',
  OTP_RESEND_BTN: 'ส่งใหม่อีกครั้ง',
  OTP_WAIT_MIN: 'นาที',
  OTP_WAIT_SEC: 'วินาที',
  SUCCESS_BTN: 'ยืนยัน',
};

export const REACT_APP_FACEBOOK_APP_ID = '1528088044747497';

export const FB_SDK_PARAMS = {
  appId: process.env.REACT_APP_FACEBOOK_APP_ID || REACT_APP_FACEBOOK_APP_ID,
  cookie: true,
  xfbml: true,
  version: 'v20.0',
};

export const BODY_KEY_UNIVERSAL_LINK = 'fb160142118013544://';
export const BODY_KEY_APPSTORE =
  'itms-apps://apps.apple.com/th/app/bodykey-app/id1017207468';
export const BODY_KEY_APP_LINK = 'bodykey://bodykey';
export const BODY_KEY_PLAYSTORE =
  'https://play.google.com/store/apps/details?id=amwaysea.inbody2014.inbody';

export const bmiValues = {
  minValue: 18.5,
  maxValue: 30,
};

export const CHALLENGE_DURATION = 60;

export const CHALLENGE_BMI_TEXT = {
  low: 'น้ำหนักต่ำกว่าเกณฑ์',
  normal: 'ร่างกายสมส่วน',
  firstLevelFat: 'อ้วนระดับ 1',
  secondLevelFat: 'อ้วนระดับ 2',
  thirdLevelFat: 'อ้วนระดับ 3',
};
export const OTHER_BADGES_MAPPING = {
  food: {
    enTitle: 'The Best Discipliner',
    id: 'best-discipliner',
    type: 'food',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วัน'
  },
  vdo: {
    enTitle: 'The Best Learner',
    id: 'best-learner',
    type: 'vdo',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วิดีโอ',
  },
  quiz: {
    enTitle: 'Top Learner',
    id: 'top-learner',
    type: 'quiz',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'คะแนน',
  },
  calorie: {
    enTitle: 'The Goal Keeper',
    id: 'goal-keeper',
    type: 'calorie',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วัน',
  },
  food_disable: {
    enTitle: 'The Best Discipliner',
    id: 'best-discipliner',
    type: 'food',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วัน',
  },
  vdo_disable: {
    enTitle: 'The Best Learner',
    id: 'best-learner',
    type: 'vdo',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วิดีโอ',
  },
  quiz_disable: {
    enTitle: 'Top Learner',
    id: 'top-learner',
    type: 'quiz',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'คะแนน',
  },
  calorie_disable: {
    enTitle: 'The Goal Keeper',
    id: 'goal-keeper',
    type: 'calorie',
    maxValueOfBadge: 60,
    minValueOfBadge: 0,
    unit: 'วัน',
  },
};

export const IMAGE_UPLOAD_INDEX_ARR = [
  'before_center',
  'before_left',
  'before_right',
  'after_center',
  'after_left',
  'after_right',
];

export const IMAGE_UPLOAD_INDEX_ARR_2026 = [
  "after_center",
  "after_left",
  "after_right",
];
export const USER_DEVICE_REGEX = /\(.*?\)/g;

export const CHALLENGE_END_STATUS = ["ongoing", "weight_end"]

export const IMAGE_UPLOAD_LOADING_STATE = {
  before_left: false,
  before_center: false,
  before_right: false,
  after_left: false,
  after_center: false,
  after_right: false,
}

export const BODY_KEY_LOADER_TITLE = 'กำลังเชื่อมต่อ'

export const BODY_KEY_VERIFY_ERROR = {
  NO_FOUND_SUPPORT_CUSTOMER: 'No data',
  IN_USE_SUPPORT_CUSTOMER: 'bodyKeyId is already associated with other account!',
  ABO_ID_NOT_FOUND: 'ABO ID not found, please try again',
  INVALID_PHONE: 'Failed to create challenge from amway id service',
  INVALID_OTP: 'Invalid OTP'
}

export const AUTO_SYNC_STEPS_TRACK = (achieved, target) => [
  {
    title: 'เผาผลาญ',
    unit: 'แคลอรี',
    value: achieved?.stepKcal || 0,
    total: target?.targetCalories || 0,
    percent: achieved?.perKcal || 0
  },
  {
    title: 'ระยะทาง',
    unit: 'กม.',
    value: round(achieved?.stepDistance, 2) || 0,
    total: round(target?.targetDistance, 2) || 0,
    percent: achieved?.perDistance || 0
  },
  {
    title: 'เวลาออกกำลังกาย',
    unit: 'นาที',
    value: achieved?.stepTime || 0,
    total: target?.exerciseTime || 0,
    percent: achieved?.perTime || 0
  },
]

export const AUTO_SYNC_STEPS_THAI = {
  SCREEN_TITLE: 'ก้าวเดินของฉัน',
  GOAL_REDIRECTION: 'แก้ไขเป้าหมายการออกกำลังกาย',
  STEP_COUNT_UNIT: 'ก้าว',
}

export const AUTO_SYNC_OTP_LENTH_LIMIT = 4;
export const dividerWidth = '20px';

export const VDO_SORTED_IDS = [
  "45a5806f-7306-4a6e-95c5-30f19ce5753c",
  "0970c5c5-f000-44cc-bcfd-7750ff9b4564",
  "db7fac8c-e5d6-4b02-8db9-2627c7e04ca3",
  "154a180f-00ae-4aa1-913a-ce22c4cf8be2",
  "c434d9b7-009c-4591-8a84-c8aecb8630c8",
  "e9f4d40f-6cc0-4502-88b0-a0c0e7e326a8",
  "d7a47405-482f-409f-9f5a-d58f0521fb2f",
  "c76dc771-640a-4f3f-bbd1-e2b8ec9347d9",
  "96ce81a3-70bd-4611-8867-8f659c43839f",
  "5e53ed99-4851-4a7b-b608-1d017961383f",
  "8eaa4c27-a377-42a2-945e-888dfa0af61d",
  "308633f7-dddf-4a13-8c7e-6e5e3610200b"
]

export const VDO_SORTED_IDS_BDK2025 = [
  "64fe12cf-f33a-4608-80a2-924c5c45c36a",
  "4cb7ab0a-8c17-4492-88e7-2024ab806636",
  "1723d5b3-4f97-4d38-89a2-ef6a13c5a0b1",
  "297613d6-a2d0-41cb-8119-0c597daca829",
  "4700c304-977a-4f3b-bb50-ab8f142168fd",
  "625644b5-b498-4122-b4a1-3828933c7ac3",
  "ecb2d425-48c1-4765-a936-af97325d0725",
  "ecc1913f-5a66-4a3c-a93e-5ba32fc96d3c",
  "f192370d-10d0-4db6-a1bb-852d7cf13ab1",
  "451f0e38-d97a-4875-905a-fe618e509c3c",
  "12b95c75-143e-492e-ade8-882ab9ef1d97",
  "179370e8-36c0-41c7-9d41-c7735f94de1c"
]

export const VDO_SORTED_IDS_BDK2026 = [
  'fe0239ff-5640-4574-b4b8-b462e006d22a',
  '791913bf-144c-450e-8e70-1db7e9238273',
  '8694d27e-9b5b-49e8-ae73-c9609242664d',
  '17a3ed68-7ac1-4314-846e-e14c957ff817',
  'b773c11a-27cd-4b69-a63e-7ebb5f29950c',
  '18b11d87-b656-4322-9606-9800c63442e5',
  '38ec2cf7-362f-4173-94bc-f0809aed8bf9',
  '9b24cf0c-73d0-4755-8c50-8a8dbc2831be',
  '369405ae-ed09-47f8-85a4-310e4585d93d',
  '37cf3c4d-2f37-441c-ba03-8cb3ab9a41b1',
  '5e42506e-5e47-46f1-a116-294efedfc6be',
  'ed567cd7-5620-4e09-ae8b-7bc74b333783',
];

export const SMALL_SCREEN_WIDTH = 376;
export const MAX_WIDTH_FOR_DIVIDER = 140;

export const ChallengeVideoStatus = {
  yet_to_watch: 'yet_to_watch',
  watch_not_fully: 'watch_not_fully',
  watch_successful: 'watch_successful',
};

export const ALIGN_CLASS = {
  1: 'align-card-1',
  2: 'align-card-2',
  3: 'align-card-3',
  4: 'align-card-4'
}